/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import { bool, func, string } from "prop-types";
import classNames from "classnames";
import I18n from "../I18n";

const SwitchToggle = ({ switchIsOn, handleToggle, labelOnKey, labelOffKey }) => (
    <div className="switch-toggle">
        <input
            checked={switchIsOn}
            onChange={handleToggle}
            className="react-switch-checkbox"
            id="react-switch-new"
            type="checkbox"
        />
        <label
            className={classNames("react-switch-label", {
                "react-switch-label-on": switchIsOn,
            })}
            htmlFor="react-switch-new">
            <span className="react-switch-button" />
        </label>
        <span className="switch-toggle-text">
            {switchIsOn ? <I18n id={labelOnKey} defaultValue="" /> : <I18n id={labelOffKey} defaultValue="" />}
        </span>
    </div>
);

SwitchToggle.propTypes = {
    switchIsOn: bool.isRequired,
    handleToggle: func.isRequired,
    labelOnKey: string,
    labelOffKey: string,
};

SwitchToggle.defaultProps = {
    labelOnKey: "",
    labelOffKey: "",
};

export default SwitchToggle;
